import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { Chip } from "@mui/material";
import moment from "jalali-moment";
import { useNavigate } from "react-router-dom";

function TicketItems({
  number = "",
  categoryName = "",
  title = "",
  createDate = "T",
  lastActionDate = "T",
  state = "",
  id = "",
}) {
  const navigate = useNavigate();

  return (
    <>
      <Grid
        container
        display={{ xs: "flex", sm: "none", md: "none" }}
        flexDirection="column"
        justifyContent="flex-end"
        alignItems="end"
        border="1px solid #DFDFDF"
        p={2}
        borderRadius={2}
        mb={1}
      >
        <Box display="flex" justifyContent="flex-end" alignItems={"center"} width="100%" my={1}>
          <Typography variant="h2" textAlign="right">
            {number}
          </Typography>
          <Typography variant="h2" color="#AAAAAA" textAlign="right" ml={3}>
            شماره تیکت
          </Typography>
        </Box>
        <Box display="flex" justifyContent="flex-end" alignItems={"center"} width="100%" my={1}>
          <Typography variant="h2" textAlign="right">
            {title}
          </Typography>
          <Typography variant="h2" color="#AAAAAA" textAlign="right" ml={3}>
            عنوان تیکت
          </Typography>
        </Box>
        <Box display="flex" justifyContent="flex-end" alignItems={"center"} width="100%" my={1}>
          {state === "بی پاسخ" && (
            <Chip
              label="بی پاسخ"
              sx={{
                width: "auto",
                height: "20px",
                background: "#FFE1EC",
                color: "#FB83AC",
                mr: 2,
              }}
            />
          )}
          {state === "پاسخ داده شده" && (
            <Chip
              label="پاسخ داده شده"
              sx={{
                width: "auto",
                height: "20px",
                background: "#8BEBD5",
                color: "#099877",
                mr: 2,
              }}
            />
          )}
          <Typography variant="h2" color="#AAAAAA" textAlign="right" ml={3}>
            وضعیت
          </Typography>
        </Box>
        <Box display="flex" justifyContent="flex-end" alignItems={"center"} width="100%" my={1}>
          <Typography variant="h2" textAlign="right">
            {categoryName}
          </Typography>
          <Typography variant="h2" color="#AAAAAA" textAlign="right" ml={3}>
            دسته بندی
          </Typography>
        </Box>
        <Box display="flex" justifyContent="flex-end" alignItems={"center"} width="100%" my={1}>
          <Typography variant="h2" textAlign="right" sx={{ direction: "ltr" }}>
            {moment(createDate, "YYYY-MM-DDTHH:mm:ss Z").format("jYYYY/jMM/jDD - HH:mm")}
          </Typography>
          <Typography variant="h2" color="#AAAAAA" textAlign="right" ml={3}>
            تاریخ ثبت
          </Typography>
        </Box>
        <Box display="flex" justifyContent="flex-end" alignItems={"center"} width="100%" my={1}>
          <Typography variant="h2" textAlign="right" sx={{ direction: "ltr" }}>
            {moment(lastActionDate, "YYYY-MM-DDTHH:mm:ss Z").format("jYYYY/jMM/jDD - HH:mm")}
          </Typography>
          <Typography variant="h2" color="#AAAAAA" textAlign="right" ml={3}>
            تاریخ آخرین اقدام
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" alignItems={"center"} width="100%" my={1}>
          <Button variant="s1" onClick={() => navigate(`/ticketing-chat/${id}`)}>
            مشاهده
          </Button>
          <Typography variant="h2" color="#AAAAAA" textAlign="right" ml={3}></Typography>
        </Box>
      </Grid>
      <Grid
        container
        display={{ xs: "none", sm: "flex", md: "flex" }}
        justifyContent="flex-end"
        alignItems="center"
        flexWrap="wrap"
        border="1px solid #DFDFDF"
        p={2}
        borderRadius={2}
        mb={1}
      >
        <Grid item xs={1}>
          <Button
            variant="s1"
            textAlign="right"
            onClick={() => {
              navigate(`/ticketing-chat/${id}`);
            }}
          >
            مشاهده
          </Button>
        </Grid>
        <Grid item xs={1.7}>
          <Typography variant="h2" textAlign="right" sx={{ direction: "ltr" }}>
            {moment(lastActionDate, "YYYY-MM-DDTHH:mm:ss Z").format("jYYYY/jMM/jDD - HH:mm")}
          </Typography>
        </Grid>
        <Grid item xs={1.7}>
          <Typography variant="h2" textAlign="right" sx={{ direction: "ltr" }}>
            {moment(createDate, "YYYY-MM-DDTHH:mm:ss Z").format("jYYYY/jMM/jDD - HH:mm")}
          </Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="h2" textAlign="right">
            {categoryName}
          </Typography>
        </Grid>
        <Grid item xs={1.5} display="flex" justifyContent="flex-end">
          {state === "بی پاسخ" && (
            <Chip
              label="بی پاسخ"
              sx={{
                width: "auto",
                height: "20px",
                background: "#FFE1EC",
                color: "#FB83AC",
              }}
            />
          )}
          {state === "پاسخ داده شده" && (
            <Chip
              label="پاسخ داده شده"
              sx={{
                width: "auto",
                height: "20px",
                background: "#8BEBD5",
                color: "#099877",
              }}
            />
          )}
        </Grid>
        <Grid item xs={3}>
          <Typography variant="h2" textAlign="right">
            {title}
          </Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="h2" textAlign="right">
            {number}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

export default TicketItems;
